/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './lens-specification.reducer';

export const LensSpecification = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const lensSpecificationList = useAppSelector(state => state.lensSpecification.entities);
  const loading = useAppSelector(state => state.lensSpecification.loading);
  const totalItems = useAppSelector(state => state.lensSpecification.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="lens-specification-heading" data-cy="LensSpecificationHeading">
        <Translate contentKey="tinyMedicRestApp.lensSpecification.home.title">Lens Specifications</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.lensSpecification.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/lens-specification/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.lensSpecification.home.createLabel">Create new Lens Specification</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.lensSpecification.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {lensSpecificationList && lensSpecificationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('issuedDate')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.issuedDate">Issued Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('issuedDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('visionProductType')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.visionProductType">Vision Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('visionProductType')} />
                </th>
                <th className="hand" onClick={sort('eyeSide')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.eyeSide">Eye Side</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eyeSide')} />
                </th>
                <th className="hand" onClick={sort('sphere')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.sphere">Sphere</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sphere')} />
                </th>
                <th className="hand" onClick={sort('cylinder')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.cylinder">Cylinder</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cylinder')} />
                </th>
                <th className="hand" onClick={sort('axis')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.axis">Axis</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('axis')} />
                </th>
                <th className="hand" onClick={sort('prismAmount')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.prismAmount">Prism Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prismAmount')} />
                </th>
                <th className="hand" onClick={sort('prismBase')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.prismBase">Prism Base</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prismBase')} />
                </th>
                <th className="hand" onClick={sort('mlPower')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.mlPower">Ml Power</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mlPower')} />
                </th>
                <th className="hand" onClick={sort('clPower')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.clPower">Cl Power</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clPower')} />
                </th>
                <th className="hand" onClick={sort('clBackCurve')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.clBackCurve">Cl Back Curve</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clBackCurve')} />
                </th>
                <th className="hand" onClick={sort('clDiameter')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.clDiameter">Cl Diameter</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clDiameter')} />
                </th>
                <th className="hand" onClick={sort('wearingDuration')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.wearingDuration">Wearing Duration</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('wearingDuration')} />
                </th>
                <th className="hand" onClick={sort('color')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.color">Color</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('color')} />
                </th>
                <th className="hand" onClick={sort('brand')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.brand">Brand</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('brand')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('eyeReadingType')}>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.eyeReadingType">Eye Reading Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eyeReadingType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.prescription">Prescription</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.lensSpecification.eye">Eye</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {lensSpecificationList.map((lensSpecification, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/lens-specification/${lensSpecification.id}`} color="link" size="sm">
                      {lensSpecification.id}
                    </Button>
                  </td>
                  <td>{lensSpecification.issuedDate}</td>
                  <td>{lensSpecification.active ? 'true' : 'false'}</td>
                  <td>{lensSpecification.timestampEntry}</td>
                  <td>{lensSpecification.microSec}</td>
                  <td>{lensSpecification.lastUpdated}</td>
                  <td>{lensSpecification.cursor}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.VisionProductType.${lensSpecification.visionProductType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EyeSide.${lensSpecification.eyeSide}`} />
                  </td>
                  <td>{lensSpecification.sphere}</td>
                  <td>{lensSpecification.cylinder}</td>
                  <td>{lensSpecification.axis}</td>
                  <td>{lensSpecification.prismAmount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PrismVisualBase.${lensSpecification.prismBase}`} />
                  </td>
                  <td>{lensSpecification.mlPower}</td>
                  <td>{lensSpecification.clPower}</td>
                  <td>{lensSpecification.clBackCurve}</td>
                  <td>{lensSpecification.clDiameter}</td>
                  <td>{lensSpecification.wearingDuration}</td>
                  <td>{lensSpecification.color}</td>
                  <td>{lensSpecification.brand}</td>
                  <td>{lensSpecification.notes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EyeReadingType.${lensSpecification.eyeReadingType}`} />
                  </td>
                  <td>
                    {lensSpecification.prescription ? (
                      <Link to={`/lens-prescription/${lensSpecification.prescription.id}`}>{lensSpecification.prescription.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{lensSpecification.eye ? <Link to={`/eye/${lensSpecification.eye.id}`}>{lensSpecification.eye.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/lens-specification/${lensSpecification.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/lens-specification/${lensSpecification.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/lens-specification/${lensSpecification.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.home.notFound">No Lens Specifications found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={lensSpecificationList && lensSpecificationList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default LensSpecification;
